const HiddenComposer = () => null;

export default HiddenComposer;
